import React, { useRef } from 'react';
import { FaTwitch, FaDiscord, FaYoutube, FaInstagram, FaTwitter, FaTiktok, FaSteam } from 'react-icons/fa';
import logo from '../assets/logo.png';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const faceitRef = useRef<HTMLImageElement>(null);
  const handleFaceitHover = () => {
    if (faceitRef.current) {
      faceitRef.current.style.filter = 'brightness(0) saturate(100%) sepia(100%) hue-rotate(-20deg) brightness(1.2) invert(16%) sepia(99%) saturate(7492%) hue-rotate(-7deg) brightness(1.01) contrast(119%)';
    }
  };
  const handleFaceitOut = () => {
    if (faceitRef.current) {
      faceitRef.current.style.filter = 'brightness(0) invert(1)';
    }
  };
  return (
    <footer className="w-full bg-[#000000] border-t border-[#000000] py-10 mt-12">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
        {/* Left: Logo */}
        <div className="flex flex-col items-center md:items-start space-y-2">
          <div className="flex items-center space-x-2">
            <Link to="/" className="flex items-center space-x-3">
              <img src={logo} alt="Logo" className="w-8 h-8 rounded-full object-cover border-4 border-white" />
              <span className="font-extrabold text-lg tracking-widest text-white">150k_btw</span>
            </Link>
          </div>
        </div>
        {/* Center: Main Links */}
        <div className="flex flex-col items-center">
          <div className="flex space-x-6">
            <Link to="/" className="text-gray-300 hover:text-purple-400 transition-colors">Home</Link>
            <Link to="/settings" className="text-gray-300 hover:text-purple-400 transition-colors">Settings</Link>
            <Link to="/faq" className="text-gray-300 hover:text-purple-400 transition-colors">Faqs</Link>
            <Link to="/rewards" className="text-gray-300 hover:text-purple-400 transition-colors">Rewards</Link>
          </div>
        </div>
        {/* Right: Social Icons */}
        <div className="flex flex-col items-center md:items-end">
          <span className="uppercase text-gray-400 font-bold mb-2 tracking-widest">Stay Connected</span>
          <div className="flex space-x-4 text-2xl">
            {/* Faceit icon */}
            <a href="https://www.faceit.com/de/players/mika666" target="_blank" rel="noopener noreferrer"
              className="transition-colors"
              style={{ display: 'flex', alignItems: 'center' }}
              onMouseOver={handleFaceitHover}
              onMouseOut={handleFaceitOut}
            >
              <img
                ref={faceitRef}
                src="/fafaceit.webp"
                alt="Faceit"
                className="w-8 h-8 object-contain transition-all duration-200"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </a>
            <a href="https://steamcommunity.com/profiles/76561198088755702" target="_blank" className="text-white hover:text-red-500 transition-colors"><FaSteam /></a>
            <a href="https://www.twitch.tv/150k_btw" target="_blank" className="text-white hover:text-red-500 transition-colors"><FaTwitch /></a>
            <a href="https://discord.gg/CwX4TQxszq" target="_blank" className="text-white hover:text-red-500 transition-colors"><FaDiscord /></a>
            <a href="https://www.youtube.com/@150kbtw" target="_blank" className="text-white hover:text-red-500 transition-colors"><FaYoutube /></a>
            <a href="https://www.instagram.com/150kbtw/" target="_blank" className="text-white hover:text-red-500 transition-colors"><FaInstagram /></a>
            <a href="https://x.com/150kbtw" target="_blank" className="text-white hover:text-red-500 transition-colors"><FaTwitter /></a>
            <a href="https://www.tiktok.com/@150kbtw" target="_blank" className="text-white hover:text-red-500 transition-colors"><FaTiktok /></a>
          </div>
        </div>
      </div>
      <div className="text-center text-gray-500 text-xs mt-8"><p>Copyright © 2024. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer; 